import { useMutation } from "@tanstack/react-query";
import { useNavigate } from "react-router-dom";
import { DCSQueryClient } from "../../../../queryClient";
import { SectionHeader } from "../../../../components/SectionHeader/SectionHeader";
import { useToast } from "../../../../Providers/ToastProvider";
import { requests } from "../../../../services/http-common";
import { LeadForm } from "../LeadForm/LeadForm";

type LeadEditProps = {
  leadId?: string;
};

export const LeadEdit = ({ leadId }: LeadEditProps) => {
  const navigate = useNavigate();
  const { show } = useToast();

  const updateLead = useMutation({
    mutationFn: (newLead: any) => {
      return requests.put(`/lead/${leadId}`, { ...newLead });
    },
    onSuccess: () => {
      show({ detail: "Lead was updated successfully !" });
      navigate("/sales/leads");
      DCSQueryClient.invalidateQueries({ queryKey: ["leads-list"] });
    },
    onError: (error: any) => {
      show({
        severity: "error",
        detail: error.response?.data?.error?.message || "Something went wrong ",
      });
    },
  });

  return (
    <>
      <SectionHeader title="Edit Lead" />
      <LeadForm
        onSubmit={updateLead.mutate}
        leadId={leadId}
        isEditForm
        isPending={updateLead.isLoading}
      />
    </>
  );
};
